import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/front-common/src/components/BaseConditions/BaseConditions.styled.ts",
    _templateObject2,
    _templateObject3;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
export var InputWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n"])));
export var DisabledWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  opacity: 0.7;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  background: #eee;\n  border-radius: 4px;\n  z-index: 9999;\n"])));
export var AutocompleteCloseIconWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & path {\n    transition: all ease-out 0.2s;\n    fill: #353b60;\n  }\n"])));